import React, { Component } from 'react';
import { Panel } from 'react-bootstrap';
import { Field } from 'redux-form';
import { Input, Radio } from '../../../common/components/formControls';
import { withNamespaces } from 'react-i18next';

const yesNoOptions = (t) => {
	return [
		{ value: 'true', label: t('Yes') },
		{ value: 'false', label: t('No') }
	];
};

const parseBoolean = value => value === 'true' ? true : false;

class MedicalInformationForm extends Component {

	componentWillReceiveProps(nextProps) {
		if (this.props.currentFormValues) {
			const calculatedFields = this.getCalculatedFields(nextProps.currentFormValues);
			Object.keys(calculatedFields).forEach(field => {
				const nextValue = calculatedFields[field];
				if (this.props.currentFormValues[field] !== nextValue) {
					this.props.changeFormValue(field, nextValue);
				}
			});
		}
	}

	getCalculatedFields(formValues) {
		var hasAnyMedicalInformation = formValues['doesHaveAllergiesOrSensitivities'] ||
			formValues['hasDiagnosedAtRiskOfAnaphylaxsis'] || formValues['doesHaveAutoInjectionDevice'] ||
			formValues['hasAnaphylaxsisMedicalPlanProvided'] || formValues['doesHaveOtherMedicalConditions'] ||
			formValues['doesHaveDietaryRestrictions'];

		return { hasAnyMedicalInformation };
	}

	render() {
		const { t, isReadOnly } = this.props;

		const colSize = { labelCol: 4, valueCol: 8 };

		return <div>
			<Panel>
				<Panel.Body>
					<Field name='nameRegularDoctor' component={Input} horizontal type='text' label={t('FO_Child_NameRegularDoctor')} required disabled={isReadOnly} {...colSize} />
					<Field name='addressRegularDoctor' component={Input} horizontal type='text' label={t('FO_Child_AddressRegularDoctor')} required disabled={isReadOnly} {...colSize} />
					<Field name='contactNumberRegularDoctor' component={Input} horizontal type='text' label={t('FO_Child_ContactNumberRegularDoctor')} required disabled={isReadOnly} {...colSize} />
					<Field name='doesHaveAmbulanceCover' component={Radio} entries={yesNoOptions(t)} parse={parseBoolean} inline horizontal label={t('FO_Child_DoesHaveAmbulanceCover')} required disabled={isReadOnly} {...colSize} />
					<Field name='hasBeenImmunised' component={Radio} entries={yesNoOptions(t)} parse={parseBoolean} inline horizontal label={t('FO_Child_HasBeenImmunised')} required disabled={isReadOnly} {...colSize} />
					<Field name='doesHaveAllergiesOrSensitivities' component={Radio} entries={yesNoOptions(t)} parse={parseBoolean} inline horizontal label={t('FO_Child_DoesHaveAllergiesOrSensitivities')} required disabled={isReadOnly} {...colSize} />
					<Field name='allergiesOrSensitivities' component={Input} horizontal type='text' label={t('FO_Child_AllergiesOrSensitivities')} disabled={isReadOnly} {...colSize} />
					<Field name='hasDiagnosedAtRiskOfAnaphylaxsis' component={Radio} entries={yesNoOptions(t)} parse={parseBoolean} inline horizontal label={t('FO_Child_HasDiagnosedAtRiskOfAnaphylaxsis')} required disabled={isReadOnly} {...colSize} />
					<Field name='doesHaveAutoInjectionDevice' component={Radio} entries={yesNoOptions(t)} parse={parseBoolean} inline horizontal label={t('FO_Child_DoesHaveAutoInjectionDevice')} required disabled={isReadOnly} {...colSize} />
					<Field name='hasAnaphylaxsisMedicalPlanProvided' component={Radio} entries={yesNoOptions(t)} parse={parseBoolean} inline horizontal label={t('FO_Child_HasAnaphylaxsisMedicalPlanProvided')} required disabled={isReadOnly} {...colSize} />
					<Field name='doesHaveOtherMedicalConditions' component={Radio} entries={yesNoOptions(t)} parse={parseBoolean} inline horizontal label={t('FO_Child_DoesHaveOtherMedicalConditions')} required disabled={isReadOnly} {...colSize} />
					<Field name='otherMedicalConditions' component={Input} horizontal type='text' label={t('FO_Child_OtherMedicalConditions')} disabled={isReadOnly} {...colSize} />
					<Field name='doesHaveDietaryRestrictions' component={Radio} entries={yesNoOptions(t)} parse={parseBoolean} inline horizontal label={t('FO_Child_DoesHaveDietaryRestrictions')} required disabled={isReadOnly} {...colSize} />
					<Field name='dietaryRestrictions' component={Input} horizontal type='text' label={t('FO_Child_DietaryRestrictions')} disabled={isReadOnly} {...colSize} />
				</Panel.Body>
			</Panel>
		</div>;
	}
};

export default withNamespaces(props => props.resourcesNamespace)(MedicalInformationForm);

export const RequiredFields = [
	'nameRegularDoctor',
	'addressRegularDoctor',
	'contactNumberRegularDoctor',
	'doesHaveAmbulanceCover',
	'hasBeenImmunised',
	'doesHaveAllergiesOrSensitivities',
	'hasDiagnosedAtRiskOfAnaphylaxsis',
	'doesHaveAutoInjectionDevice',
	'hasAnaphylaxsisMedicalPlanProvided',
	'doesHaveOtherMedicalConditions',
	'doesHaveDietaryRestrictions'
];

export const ValidationFunc = (values, t) => {
	let errors = {};

	if (values.doesHaveAllergiesOrSensitivities && !values.allergiesOrSensitivities) {
		errors['allergiesOrSensitivities'] = t('Validator_Required');
	}
	if (!values.doesHaveAllergiesOrSensitivities && values.allergiesOrSensitivities) {
		errors['allergiesOrSensitivities'] = t('Validator_NotAllowed');
	}
	if (values.doesHaveOtherMedicalConditions && !values.otherMedicalConditions) {
		errors['otherMedicalConditions'] = t('Validator_Required');
	}
	if (!values.doesHaveOtherMedicalConditions && values.otherMedicalConditions) {
		errors['otherMedicalConditions'] = t('Validator_NotAllowed');
	}
	if (values.doesHaveDietaryRestrictions && !values.dietaryRestrictions) {
		errors['dietaryRestrictions'] = t('Validator_Required');
	}
	if (!values.doesHaveDietaryRestrictions && values.dietaryRestrictions) {
		errors['dietaryRestrictions'] = t('Validator_NotAllowed');
	}

	return errors;
};